import script from "./EmployeeDocumentsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeDocumentsView.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeDocumentsView.vue?vue&type=style&index=0&id=0c4800b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4800b1"]])

export default __exports__